var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthCioChiefInformationOfficerBadge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 65,
    viewBox: "0 0 70 65",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.878 1.238s-3.31-1.234-7.6-1.234c0 0-5.46-.26-10.277 3.508C30.184-.257 24.723.004 24.723.004c-4.291 0-7.6 1.234-7.6 1.234C8.579 4.27 2.917 12.255 2.917 21.832c0 5.8 1.457 11.498 7.197 17.845l24.871 24.477.016.013.014-.013 24.873-24.477c5.738-6.347 7.195-12.045 7.195-17.845 0-9.577-5.662-17.562-14.205-20.594z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 3.512C30.185-.257 24.724.004 24.724.004c-4.291 0-7.6 1.234-7.6 1.234C8.579 4.27 2.917 12.255 2.917 21.832c0 5.8 1.457 11.498 7.197 17.845L35 64.167V3.512z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.195 12.552C51.3 9.599 48.207 8.02 43.168 8.02c-5.48.089-7.937 3.249-8.168 3.485-.231-.236-2.69-3.396-8.168-3.485-5.04 0-8.133 1.578-11.027 4.53-6.105 6.227-5.04 17.422.484 23.056L35 54.687l18.71-19.08c5.526-5.634 6.59-16.83.485-23.055z",
    fill: "#FF0008"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 11.506c-.231-.236-2.69-3.396-8.168-3.485-5.04 0-8.133 1.578-11.027 4.53-6.105 6.227-5.04 17.422.484 23.056L35 54.687V11.506z",
    fill: "#FF4C52"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.573 26.838h-8.244v-8.244h-4.658v8.244h-8.244v4.658h8.244v8.244h4.658v-8.244h8.244z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthCioChiefInformationOfficerBadge);
export default __webpack_public_path__ + "static/media/health-cio-chief-information-officer-badge.7a6f13266f6a900f8abde4e035cd9d0f.svg";
export { ForwardRef as ReactComponent };